// 사용자 주석 액션 — 정의 목록 · 연결별 영역(연결할 때 영역 조회 쿼리를 돌려 리덕스에 둔다, docs/features/32-user-comment.md)
import { listDefs, fetchAreas } from '../../services/userComments';

export const UCMT_DEFS_LOADED = 'UCMT_DEFS_LOADED';
export const UCMT_AREAS_START = 'UCMT_AREAS_START';
export const UCMT_AREAS_DONE = 'UCMT_AREAS_DONE';
export const UCMT_AREAS_RESET = 'UCMT_AREAS_RESET';
export const UCMT_AREAS_CLEAR = 'UCMT_AREAS_CLEAR';

/** 정의 목록을 다시 받고, 영역은 비운다 — 매핑·쿼리가 바뀌었을 수 있다(App 이 연결된 것부터 다시 받는다) */
export const loadUserCommentDefs = () => async (dispatch) => {
    try {
        const r = await listDefs();
        dispatch({ type: UCMT_AREAS_RESET });
        dispatch({ type: UCMT_DEFS_LOADED, payload: r.defs || [] });
    } catch (_e) {
        // 로그인 전·서버 없음 — 사용자 주석 없이 돈다
        dispatch({ type: UCMT_DEFS_LOADED, payload: [] });
    }
};

const inFlight = new Set();
// 영역 조회가 실패한 연결은 잠시 뒤 다시 받는다(2026-11-04) — 예전에는 실패 상태가 「받아 둔 것」 으로 남아 정의를 다시 받을 때까지
// 재시도하지 않았다. 실패 기록을 지우면 App 의 효과가 그 연결을 다시 부른다. 연달아 실패하면 30초 → 1분 → … 10분까지 늘린다.
const failCount = new Map();
const retryDelay = (n) => Math.min(10 * 60 * 1000, 30 * 1000 * (2 ** Math.max(0, n - 1)));
/** n 번째 연달은 실패 뒤 다시 받기까지 기다리는 시간(ms) */
export const areasRetryDelay = retryDelay;
export const loadUserCommentAreas = (connectionId) => async (dispatch) => {
    if (!connectionId || inFlight.has(connectionId)) return;
    inFlight.add(connectionId);
    dispatch({ type: UCMT_AREAS_START, connectionId });
    try {
        const r = await fetchAreas(connectionId);
        dispatch({ type: UCMT_AREAS_DONE, connectionId, areas: r.areas || [], errors: r.errors || [] });
        if (r.errors && r.errors.length) scheduleRetry(dispatch, connectionId); else failCount.delete(connectionId);
    } catch (e) {
        dispatch({ type: UCMT_AREAS_DONE, connectionId, areas: [], errors: [], error: (e && e.message) || 'error' });
        // 로그인이 끊긴 401 은 다시 부르지 않는다 — 로그인 대기 중 반복 호출이 QBase 세션 확인으로 쌓인 적이 있다(CLAUDE.md 로그인 폴링)
        if (!(e && e.response && e.response.status === 401)) scheduleRetry(dispatch, connectionId);
    } finally {
        inFlight.delete(connectionId);
    }
};

function scheduleRetry(dispatch, connectionId) {
    const n = (failCount.get(connectionId) || 0) + 1;
    failCount.set(connectionId, n);
    setTimeout(() => dispatch({ type: UCMT_AREAS_CLEAR, connectionId }), retryDelay(n));
}
